
export class RefreshToken {
    userName!:String
}
  